import React, { useState } from 'react';
import { useBooking } from '../context/BookingContext';
import { useLanguage } from '../context/LanguageContext';
import '../styles/BookingModal.css';

const BookingModal = () => {
  const { isBookingOpen, closeBooking } = useBooking();
  const { language } = useLanguage();
  const [isLoading, setIsLoading] = useState(true);

  if (!isBookingOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeBooking();
    }
  };

  return (
    <div className="booking-modal-overlay" onClick={handleOverlayClick}>
      <div className="booking-modal">
        {/* Header */}
        <div className="booking-modal-header">
          <div className="booking-modal-title-group">
            <span className="booking-modal-icon">✂️</span>
            <div>
              <h3 className="booking-modal-title">
                {language === 'fr' ? 'Réserver un créneau' : 'Book a slot'}
              </h3>
              <p className="booking-modal-subtitle">
                {language === 'fr'
                  ? 'Choisissez la date et l\'heure qui vous conviennent'
                  : 'Choose the date and time that suits you'}
              </p>
            </div>
          </div>
          <button className="booking-modal-close" onClick={closeBooking} aria-label="Fermer">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Zcal Iframe */}
        <div className="booking-modal-body">
          {isLoading && (
            <div className="booking-loader">
              <div className="booking-spinner"></div>
              <span>{language === 'fr' ? 'Chargement du calendrier...' : 'Loading calendar...'}</span>
            </div>
          )}
          <iframe
            src="https://zcal.co/i/dkTVXSF7?embed=1&embedType=iframe"
            loading="lazy"
            className="booking-iframe"
            title={language === 'fr' ? 'Réservation Alpha Barber' : 'Alpha Barber Booking'}
            id="zcal-invite"
            scrolling="auto"
            onLoad={() => setIsLoading(false)}
          />
        </div>

        {/* Footer */}
        <div className="booking-modal-footer">
          <a
            href="https://zcal.co/i/dkTVXSF7"
            target="_blank"
            rel="noopener noreferrer"
            className="booking-external-link"
          >
            {language === 'fr' ? 'Ouvrir dans un nouvel onglet' : 'Open in a new tab'}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
              <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
